import React from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";
import {
    Timelapse as TimelapseIcon,
    Timer as TimerIcon
} from "@mui/icons-material"

const SimulateTimers = ({ data }) => {

    return (
        <Grid container direction="column" justifyContent="center" alignItems="center" mt="15px">
            <Grid item xs={12}>
                <Typography
                    align="center"
                    style={{
                        textTransform: 'uppercase',
                        fontWeight: '900'
                    }}
                >
                    Tempo investido
                </Typography>
            </Grid>
            <Grid container item justifyContent="space-between" alignItems="center" padding="13px">
                <Grid container item xs={4} alignContent="center">
                    <TimelapseIcon color="cardsText" />
                    <Box component={'b'} ml="5px" color="cardsText">
                        Total:
                    </Box>
                </Grid>
                <Grid item>
                    <Box component={'b'} color="cardsText">
                        {data.tempoGasto.substring(11, 19)}
                    </Box>
                </Grid>
            </Grid>

            <Divider variant="fullWidth" sx={{ width: '100%' }} />

            <Grid container item xs={12} justifyContent="space-between" alignContent="center" padding="13px">
                <Grid container item xs={6} alignContent="center">
                    <TimerIcon color="cardsText" />
                    <Box component="b" ml="5px" color="cardsText">
                        Médio por questão
                    </Box>
                </Grid>
                <Grid item>
                    <Box component={'b'} color="cardsText">
                        {data.tempoMedioQuestao.substring(11, 19)}
                    </Box>
                </Grid>
            </Grid>

        </Grid>
    )
}

export default SimulateTimers;